// @ts-nocheck



import CommonApi from '../commonApi';
import {
  convertFromKopToRub,
  convertFromRubToKop,
  convertFromKmToM,
  convertFromMToKm } from
'../pure/unitConversions';
import { fetchRequest } from './index';

export const convertDataToServer = (
federalHighwayCalculationMonth) => (
{
  ...federalHighwayCalculationMonth,
  plannedKilometrage: convertFromKmToM(
    federalHighwayCalculationMonth.plannedKilometrage
  ),
  cost: convertFromRubToKop(federalHighwayCalculationMonth.cost)
});

export const convertDataFromServer = (
federalHighwayCalculationMonth) => (
{
  ...federalHighwayCalculationMonth,
  plannedKilometrage: convertFromMToKm(
    federalHighwayCalculationMonth.plannedKilometrage
  ),
  cost: convertFromKopToRub(federalHighwayCalculationMonth.cost)
});

const basedUrl = 'federalHighwayCalculationMonth';
const federalHighwayCalculationMonth = new CommonApi(
  basedUrl,
  'расчет проезда по федеральным трассам',
  convertDataToServer,
  convertDataFromServer
);

export const updateCalculations = async (
data) =>
{
  const updated = await fetchRequest.put(
    `/${basedUrl}/updateCalculation`,
    convertDataToServer(data)
  );
  if (updated) return convertDataFromServer(updated);
  throw new Error(`Не удалось отредактировать`);
};

export default {
  ...federalHighwayCalculationMonth,
  updateCalculations
};
